/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  ContentItem,
  ContentItemSlug,
  ContentItemStatus, ProfileStudy,
} from '~/utils/generated/graphql'

export function getTypeName(contentItem: ContentItemTypes | ContentItem): string {
  const ci: any = contentItem as unknown as any
  return ci.__typename
}

export function getItemImageUrl(item: Maybe<ContentItemTypes>): string | null {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (!item || !item.media || item.media.length === 0 || item.media[0].sources.length === 0) return null
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return item.media[0].sources[0].url
}

export function getPageLink(contentItem: ContentItemTypes, profileStudy: ProfileStudy | undefined = undefined): string {
  // eslint-disable-next-line no-prototype-builtins
  if (!contentItem.hasOwnProperty('slug')) return ''
  const typeName = getTypeName(contentItem)

  const slug = contentItem as any as ContentItemSlug
  switch (typeName) {
    case 'Study':
      // eslint-disable-next-line no-prototype-builtins
      if (contentItem.hasOwnProperty('nextSessionId')) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return '/studies/' + slug.slug + '/' + contentItem?.nextSessionId.split('-')[1]
      }
      else if (profileStudy && profileStudy.nextSessionId) {
        return '/studies/' + slug.slug + '/' + profileStudy.nextSessionId!.split('-')[1]
      }
      return '/studies/' + slug.slug
    case 'PodcastEpisode':
      return '/episodes/' + slug.slug
    case 'Person':
      return '/people/' + slug.slug
    case 'Song':
      return '/worship/' + slug.slug
    case 'Message':
      return '/talks/' + slug.slug
    default:
      return '/' + typeName?.toLowerCase() + 's/' + slug.slug
  }
}

export type ContentItemTypes =
  {
    __typename?: 'Album'
    id: string
    title: string
    slug: string
    date?: any
    description?: string | null | undefined
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
  } |
  {
    __typename?: 'Article'
    date?: any | null
    slug: string
    id: string
    title: string
    description?: string | null
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
    authors: Array<{
      __typename?: 'Person'
      id: string
      title: string
      description?: string | null
      media: Array<{
        __typename?: 'Media'
        sources: Array<{ __typename?: 'Audio' } | {
          __typename?: 'Image'
          url?: string | null
          height?: number | null
          width?: number | null
        } | { __typename?: 'Video' }>
      }>
    }>
  } | {
    __typename?: 'Collection'
    date?: any | null
    slug: string
    id: string
    title: string
    description?: string | null
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
  } | { __typename?: 'Daily'
    id: string
    title: string
    slug?: string
    description?: string | null
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
  } | {
    __typename?: 'DevotionalItem'
    id: string
    title: string
    slug?: string
    description?: string | null
  } | { __typename?: 'LongTextItem', id: string, title: string, description?: string | null, slug?: string | null } | {
    __typename?: 'Message'
    date?: any | null
    slug: string
    id: string
    title: string
    description?: string | null
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
    authors: Array<{
      __typename?: 'Person'
      id: string
      title: string
      description?: string | null
      slug?: string | null
      media: Array<{
        __typename?: 'Media'
        sources: Array<{ __typename?: 'Audio' } | {
          __typename?: 'Image'
          url?: string | null
          height?: number | null
          width?: number | null
        } | { __typename?: 'Video' }>
      }>
    }>
  } | { __typename?: 'Person', id: string, title: string, description?: string | null, slug?: string | null } | {
    __typename?: 'Podcast'
    date?: any | null
    slug: string
    id: string
    title: string
    description?: string | null
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
    authors: Array<{
      __typename?: 'Person'
      id: string
      title: string
      description?: string | null
      media: Array<{
        __typename?: 'Media'
        sources: Array<{ __typename?: 'Audio' } | {
          __typename?: 'Image'
          url?: string | null
          height?: number | null
          width?: number | null
        } | { __typename?: 'Video' }>
      }>
    }>
  } | { __typename?: 'PodcastEpisode', id: string, slug?: string, title: string, description?: string | null } | {
    __typename?: 'PrayerItem'
    id: string
    title: string
    slug?: string
    description?: string | null
  } | { __typename?: 'ScriptureItem', id: string, title: string, slug?: string, description?: string | null } | {
    __typename?: 'Song'
    date?: any | null
    slug: string
    id: string
    title: string
    description?: string | null
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
    authors: Array<{
      __typename?: 'Person'
      id: string
      title: string
      description?: string | null
      media: Array<{
        __typename?: 'Media'
        sources: Array<{ __typename?: 'Audio' } | {
          __typename?: 'Image'
          url?: string | null
          height?: number | null
          width?: number | null
        } | { __typename?: 'Video' }>
      }>
    }>
  } | {
    __typename?: 'Study'
    date?: any | null
    slug: string
    id: string
    title: string
    description?: string | null
    media: Array<{
      __typename?: 'Media'
      sources: Array<{ __typename?: 'Audio' } | {
        __typename?: 'Image'
        url?: string | null
        height?: number | null
        width?: number | null
      } | { __typename?: 'Video' }>
    }>
    authors: Array<{
      __typename?: 'Person'
      id: string
      title: string
      description?: string | null
      media: Array<{
        __typename?: 'Media'
        sources: Array<{ __typename?: 'Audio' } | {
          __typename?: 'Image'
          url?: string | null
          height?: number | null
          width?: number | null
        } | { __typename?: 'Video' }>
      }>
    }>
  } | { __typename?: 'StudySession', id: string, slug?: string, title: string, description?: string | null } | {
    __typename?: 'Topic'
    id: string
    title: string
    slug?: string
    description?: string | null
  } | { __typename?: 'VideoItem', id: string, title: string, description?: string | null, slug?: string | null } |
  {
    bibleReferences: { __typename?: 'BibleReference' | undefined, human: string, usfm: string }[]
    date?: any
    description?: Maybe<string> | undefined
    id: string
    status: ContentItemStatus
    tags: string[]
    title: string
    slug?: string | null
    __typename: string
  }
